module.exports = __webpack_public_path__ + "img/phone_bg.5326fe93.png";